/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import { Accordion } from 'react-bootstrap';

export const HeaderStyle: any = {};

export const AccordionStyle: any = {
  backgroundColor: 'rgba(255,255,255, 0.4)',
};

export const AccordionComponent: any = styled(Accordion)`
  .accordion-item {
    border-top: none;
    border-left: none;
    border-bottom: none;
    border-right: none;
  }
  .accordion-button:not(.collapsed) {
    background-color: transparent;
    box-shadow: none;
  }

  .accordion-button:focus {
    box-shadow: none;
  }

  hr {
    margin-top: 0 1rem !important;
  }
`;
